/** Shared helpers for the top-bar branch *view* (a read filter sent as `X-Branch-Id`). */
export const BRANCH_VIEW_KEY = "prism_view_branch";

/** Default selection for a freshly logged-in user:
 *  Company Admin → "all", Branch Admin → their own branch (auto-set), everyone else → none. */
export function defaultBranchView(user) {
  if (user?.role === "branch_admin") return user.branch_id || "all";
  if (user?.role === "admin") return "all";
  return "";
}
